var React = require('react');

function GlobalProfileEnforced (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#D6A62D","fillRule":"evenodd","d":"m8 4 5-3v2.05c5.053.501 9 4.765 9 9.95 0 5.523-4.477 10-10 10S2 18.523 2 13a9.987 9.987 0 0 1 4.14-8.104l1.807 1.205A8 8 0 1 0 13 5.061V7L8 4Zm5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2-8h2l-.5 6h-1L11 9Z","clipRule":"evenodd"}));
}

GlobalProfileEnforced.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = GlobalProfileEnforced;

GlobalProfileEnforced.default = GlobalProfileEnforced;
